export default __webpack_public_path__ + "static/media/2017 (4).08035cc4.jpg";